'use strict';

var ajax = require('../../ajax'),
    formPrepare = require('./formPrepare'),
    progress = require('../../progress'),
    tooltip = require('../../tooltip'),
    util = require('../../util'),
    bornModules = require('../../helpers/born.modules').default,
    dynamicAddress = require('../dynamic-address'),
    addressUtil = require('../../helpers/address.utils'),
    page = require("../../page"),
    login = require("../../login");

import {processPromoEntry,initCouponAction,toggleSummaryMobileView} from './billing';

var shippingMethods;
/**
 * @function
 * @description Initializes gift message box, if shipment is gift
 */
function giftMessageBox() {
	if($('textarea[name$="_shippingAddress_giftMessage"]').val()!='' && $('input[name$="_shippingAddress_isGift"]:checked').val() !== 'true'){
		$('textarea[name$="_shippingAddress_giftMessage"]').val('');
	}
    // show gift message box, if shipment is gift
    $('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val() !== 'true');
}

function toggleGiftMessageBox() {
    $('#giftMsgToggleTrigger').on('click', function () {
        $('input[name$="_shippingAddress_isGift"]:not(:checked)').trigger('click');
        if(!$('.gift-message-text').hasClass('hidden')) {
            var user = dataLayer.find(o => o.user != null).user;
            dataLayer.push({
                'event': 'custom_event',
                'eventCategory': 'checkout_page',
                'eventAction': 'checkout_gift_message_click',
                'eventLabel': 'checkout gift message click',
                'country': window.GlobalAttributes.COUNTRY,
                'language': window.GlobalAttributes.LANGUAGE,
                'screenName': 'Checkout Page',
                'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
                'userId': user.user_id != '' ? user.user_id : ''
            });
        }
    });
}

/**
 * @function
 * @description updates the order summary based on a possibly recalculated basket after a shipping promotion has been applied
 */
function updateSummary(paymentMethod,page) {
    var $summary = $('#secondary.summary');
    // indicate progress
    progress.show($summary);
    var updateSummaryUrl = Urls.summaryRefreshURL;
    if(paymentMethod!==undefined && paymentMethod!==null ){
        updateSummaryUrl = updateSummaryUrl +'?paymentMethod='+paymentMethod;
    }
    var resolve;
    const promise = new Promise((res,reject) => {
        resolve = res;
    })
    // load the updated summary area
    $summary.load(updateSummaryUrl, function () {
        // hide edit shipping method link
        $summary.fadeIn('fast');
        $summary.find('.checkout-mini-cart .minishipment .header a').hide();
        $summary.find('.order-totals-table .order-shipping .label a').hide();
        bornModules.toggle.init();
        // toggleSummaryMobileView();
        // initCouponAction('billing');
        paymentMethod == 'DW_COD'?toggleGiftCertificateSection(false):toggleGiftCertificateSection(true);
        paymentMethod == 'CHECKOUTCOM_APPLE_PAY'?toggleApplePayGiftCertificateSection(false):toggleApplePayGiftCertificateSection(true);
       resolve();
    });
    return promise;
}

function toggleGiftCertificateSection(status)
{
    if(SitePreferences.DISABLE_GC_AND_COD_COMBO) {
        !status?$('.gift-promo-toggle').hide():$('.gift-promo-toggle').show();  
    }
}
function toggleApplePayGiftCertificateSection(status)
{
    !status?$('.gift-promo-toggle').hide():$('.gift-promo-toggle').show();
}

/**
 * Sets form data if available on the sessionStorage object, then clears it.
 * @return {[type]} [description]
 */
function resetShippingFormData() {
    var parsedData = JSON.parse(window.sessionStorage.getItem('shippingFormData')),
        shippingFieldID = 'shippingAddress_addressFields';
    if (!parsedData) {
        return;
    }
 
    parsedData.forEach(function (storedField) {
        if (storedField.name.indexOf(shippingFieldID) !== -1 ) {
            var fieldEl = document.querySelector('[name="' + storedField.name + '"]');

            if(fieldEl !==undefined && fieldEl !=null){
                fieldEl.value = storedField.value;
                if (fieldEl.nodeName === 'SELECT') {
                    $(fieldEl).trigger('change');
                }
                $(fieldEl).trigger('change');
            }
        }
    });

    window.sessionStorage.removeItem('shippingFormData');
}

$('.packaging-option').on('change', function () {
    var attribute = $(this).find('input').attr('value'),
        price = $('.signature-price').data('signature');

    $.ajax({
        dataType: 'json',
        contentType: 'application/json',
        url: Urls.handlePackagingPriceSelection,
        type: 'POST',
        data: JSON.stringify({
            attribute: attribute,
            price: price
        }),
    }).always(function () {
        updateSummary();
    });
});

/**
 * @function
 * @description Helper method which constructs a URL for an AJAX request using the
 * entered address information as URL request parameters.
 */
function getShippingMethodURL(url, extraParams) {
    var $form = $('.address');
    var address3 = $form.find('input[name$="_address3"]').length > 0?$form.find('input[name$="_address3"]').val():'';
    var params = {
        address1: $form.find('input[name$="_address1"]').val(),
        address2: $form.find('input[name$="_address2"]').val(),
        address3: address3,
        countryCode: $form.find('[id$="_country"]').val(),
        stateCode: $form.find('[id$="_state"]').val(),
        postalCode: $form.find('input[name$="_postal"]').val(),
        city: $form.find('[name$="_city"]').val()
    };
    return util.appendParamsToUrl(url, $.extend(params, extraParams));
}

/**
 * @function
 * @description selects a shipping method for the default shipment and updates the summary section on the right hand side
 * @param
 */
function selectShippingMethod(shippingMethodID) {
    // nothing entered
    if (!shippingMethodID) {
        return;
    }
    // attempt to set shipping method
    var url = getShippingMethodURL(Urls.selectShippingMethodsList, {shippingMethodID: shippingMethodID});
    ajax.getJson({
        url: url,
        callback: function (data) {
            updateSummary();
            if (!data || !data.shippingMethodID) {
                window.alert('Couldn\'t select shipping method.');
                return false;
            }
            // display promotion in UI and update the summary section,
            // if some promotions were applied
            $('.shippingpromotions').empty();


            // if (data.shippingPriceAdjustments && data.shippingPriceAdjustments.length > 0) {
            //     var len = data.shippingPriceAdjustments.length;
            //     for (var i=0; i < len; i++) {
            //         var spa = data.shippingPriceAdjustments[i];
            //     }
            // }
        }
    });
}

/**
 * @function
 * @description Make an AJAX request to the server to retrieve the list of applicable shipping methods
 * based on the merchandise in the cart and the currently entered shipping address
 * (the address may be only partially entered).  If the list of applicable shipping methods
 * has changed because new address information has been entered, then issue another AJAX
 * request which updates the currently selected shipping method (if needed) and also updates
 * the UI.
 */
function updateShippingMethodList() {
    var $shippingMethodList = $('#shipping-method-list');
    if (!$shippingMethodList || $shippingMethodList.length === 0) { return; }
    var url = getShippingMethodURL(Urls.shippingMethodsJSON);

    ajax.getJson({
        url: url,
        callback: function (data) {
            if (!data) {
                console.error('Couldn\'t get list of applicable shipping methods.');
                return false;
            }
            if (shippingMethods && shippingMethods.toString() === data.toString()) {
                // No need to update the UI.  The list has not changed.
                return true;
            }

            // We need to update the UI.  The list has changed.
            // Cache the array of returned shipping methods.
            shippingMethods = data;
            // indicate progress
            progress.show($shippingMethodList);

            // load the shipping method form
            var smlUrl = getShippingMethodURL(Urls.shippingMethodsList);

            $shippingMethodList.load(smlUrl, function () {
                $shippingMethodList.fadeIn('fast');
                // rebind the radio buttons onclick function to a handler.
                $shippingMethodList.find('[name$="_shippingMethodID"]').click(function () {
                    selectShippingMethod($(this).val());
                });

                // update the summary
                updateSummary();
                progress.hide();
                // tooltip.init();
                //if nothing is selected in the shipping methods select the first one
                if ($shippingMethodList.find('.input-control:checked').length === 0) {
                    let $sameday = $shippingMethodList.find('#shipping-method-SAMEDAY');
                    if ($sameday.length) {
                        $sameday.click();
                    } else {
                        $shippingMethodList.find('.input-control:first').prop('checked', 'checked');
                    }
                    
                }
            });
        }
    });
}

/**
 * Syncs the useAsBillingAddress checkboxes to allow display under "Saved Addresses" as well.
 * @return {[type]} [description]
 */
function setupUseAsBilling() {
    var useAsBillingChecks = document.querySelectorAll('[name*="useAsBillingAddress"]');

    [].forEach.call(useAsBillingChecks, function(el){
        el.addEventListener('change', syncUseAsBilling);
    });
}

function syncUseAsBilling(evt) {
    var useAsBillingChecks = document.querySelectorAll('[name*="useAsBillingAddress"]');
    
    [].forEach.call(useAsBillingChecks, function(el){
        el.checked = this.checked;
    }.bind(this));
}

function isVisibleSavedAddress() {
    var $isVisible = $('.order--checkout--limit').is(':visible');
    if ($isVisible) {
        formPrepare.validateForm();
    }
}

function cleanAddressForm() {
    $('input[name$="_firstName"]').val('');
    $('input[name$="_lastName"]').val('');
    $('input[name$="_phone"]').val('');
    $('input[name$="_phone--dummy"]').val('');
    $('input[name$="_emailAddress"]').val('');
    $('input[name$="_address1"]').val('');
    $('input[name$="_address2"]').val('');
    $('input[name$="_address3"]').val('');
    $('input[name$="_zoneNumber"]').val('');
    $('input[name$="_unitNumber"]').val('');
    $('input[name$="_streetNumber"]').val('');
    $('input[name$="_buildingNumber"]').val('');

    var countryEl = $('[name$="_country"]');
    if(countryEl && countryEl.length > 0 && countryEl.val() == 'kw' && !addressUtil.isDependentAddress()) {
        $('select[name$="_area"]').val("").trigger("change");
        $('select[name$="_district"]').val("").trigger("change");
        $('select[name$="_area"]').parents('.field-wrapper').siblings('.error').remove();
        $('select[name$="_district"]').parents('.field-wrapper').siblings('.error').remove();
    }else{
        $('select[name$="_city"]').val("").trigger("change");
        $('select[name$="_area"]').val("").trigger("change");
        $('select[name$="_district"]').val("").trigger("change");
        $('select[name$="_city"]').parents('.field-wrapper').siblings('.error').remove();
        $('select[name$="_area"]').parents('.field-wrapper').siblings('.error').remove();
        $('select[name$="_district"]').parents('.field-wrapper').siblings('.error').remove();
    }
}

function detectEditChanges() {
    var $form = $('.address');
    $('.js-us-different-address')
        .on('click', isVisibleSavedAddress)
        .on('click', function () {
            $form.find('[id$="_editAddressBook"]').prop('checked', false);
            $form.find('[id$="_unsavedAddressBook"]').prop('checked', true);
            $form.find('input[name$="_addressList"]').prop('checked', false);
            $('.custom-address-modal').removeClass('update').addClass('new');
            $('.custom-address-modal .custom-address').removeClass('hidden');
            $('.saved-address .js-edit').addClass('hidden');
             cleanAddressForm();
             initializeAddressType();
        })
    $('.js-us-saved-address')
        .on('click', isVisibleSavedAddress)
        .on('click', function (e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
            $form.find('[id$="_editAddressBook"]').prop('checked', false);
            $form.find('[id$="_unsavedAddressBook"]').prop('checked', false);
            $form.find('input[name$="_addressList"]').prop('checked', false);
            formPrepare.validateForm(); 
            $('.saved-address .js-edit').removeClass('hidden');
        })
    $('.js-edit').on('click', function () {
        $form.find('[id$="_editAddressBook"]').prop('checked', true); 
        $form.find('[id$="_unsavedAddressBook"]').prop('checked', false);
        addressUtil.initGovernateEvents();
        addressUtil.updateGovernateInfo();
        formPrepare.validateForm();
        $($(this).data('toggler')).addClass('toggle--active');
        $('.custom-address-modal').removeClass('new').addClass('update');
        $('.custom-address-modal .custom-address').removeClass('hidden');
        scrollHere($('.custom-address-modal').first());
    });
}

function scrollHere(element) {
    $([document.documentElement, document.body]).animate({
        scrollTop: element.offset().top
    },500);
}

function isAddressSelected() {
    var $radiobuttons = $('input[name$="_addressList"]'),
        $submit = $('[type="submit"]');

    var addressBookIdValue =  $(this).data('address').ID;
    setUpAddressId(addressBookIdValue);

    for (var i = 0; i < $radiobuttons.length; i++) {
        if ($radiobuttons[i].type === 'radio' && $radiobuttons[i].checked) {
            $submit.prop('disabled', false);
            break;
        } else {
            $submit.prop('disabled', true);
        }
    }
}

function setUpAddressId(addressBookIdValue) {
    var $addressBookId = $('.address').find('[id$="_addressBookId"]');
    if ($addressBookId && addressBookIdValue) {
        $addressBookId.val(addressBookIdValue);
    }
}

function listenLoginModalClickaway() {
    var $modalWrapper = $('#loginModal');
    $('#continueAsGuest').on('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        $modalWrapper.removeClass('active');
        $('html, body').removeClass('no-scroll');
        history.pushState({},'',Urls.shipping);
    })
    $('[id$="loginCloseBtn"]').on('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        $modalWrapper.removeClass('active');
        $('html, body').removeClass('no-scroll');
        history.pushState({},'',Urls.shipping);
    })
}

function triggerMobBack() {
    $('.address-back.shipping').on('click', function () {
        $('.js-us-saved-address').first().trigger('click');
    })
}

function selectAddressType() {
    var $addressType = $('select[name$="_addressType"]');
    $('.address-type-selector').on('click','.address-type.selectable:not(.active)', function () {
        $('.address-type-selector .address-type.active').removeClass('active');
        $addressType.val($(this).data('value'));
        $(this).addClass('active');
    });
}

function savedAddressClickHandle() {
    $('.saved-address-preview').on('click', function () {
        var isChecked = false;
        $('.saved-address-preview').find('input').each(function (i, ele) {
            isChecked = $(ele).prop('checked');
            return !isChecked;
        });
        if (!isChecked) {
            $('.js-us-saved-address').trigger('click');
            setTimeout(() => {
                $(this).find('input').prop('checked', true);
            }, 0);
        }
    });
}

function heightAdjustOnCartOpen() {
    $('#mini-cart-toggler').on('click', function () {
        let heightToSet = $('#secondary').height();
        $('#checkoutSpacer.shipping').height(heightToSet - 40).toggleClass('hidden');
    })
}


$(document).ready(() => {
    if (typeof zE !== 'undefined' && !!zE) {
        zE(function () {
            zE.hide();
        });
    }
    $('#loginModalform').length && $('body').addClass('guest-checkout');
    $('.new-address:not(.guest-address-modal)').length && $('body').addClass('user-checkout-no-saved');
});
function loginModalInit() {
    var $loginForm = $('#loginModalform');
    var $submit = $loginForm.find('[name$="_login_login"]');
    $loginForm.length && $('#loginModal').hasClass('active') && $('html, body').addClass('no-scroll');
    $($submit).on('click', function (e) {
        sendLoginButtonEvent();
        if (!$loginForm.valid()) {
            return;
        }
        e.preventDefault();
        var data = $loginForm.serialize();
        data += '&' + $submit.attr('name') + '=';
        if (data.indexOf('ajax') === -1) {
            data += '&format=ajax';
        }
        $.ajax({
            type: 'POST',
            url: $loginForm.attr('action'),
            data: data,
            beforeSend:function () {
                $loginForm.find('.show-response').html('');
            },
            success: function (response) {
                if (typeof response === 'object' &&
                        !response.success &&
                        response.error === 'CSRF Token Mismatch') {
                    page.redirect(Urls.csrffailed);
                } else if (response.error !==undefined) {
                    if(response.verifyEmail !==undefined){
                        page.redirect(Urls.accountverify+'&email='+encodeURIComponent(response.customeremail));
                    }
                    showAjaxError($loginForm, '<div class="error-form">'+response.message+'</div>');
                    userLoginFailedEvent(response.message, window.GlobalAttributes.country, window.GlobalAttributes.locale);
                    if(response.showCaptcha !==undefined && response.showCaptcha) {
                        window.SessionAttributes.SHOW_CAPTCHA = true;
                        require('../../captcha')();
                    } 
                } else if (response.success !==undefined) {
                    sessionStorage.setItem('loginBtnClick', true);
                    page.redirect(Urls.shipping);
                }
            },
            failure: function () {
                showAjaxError($loginForm,  Resources.SERVER_ERROR);
            }
        });
    });
    $('#btnModalRegister').on('click',function(){
        $('.registerModalForm').removeClass('hidden');
        $('#loginModalform').addClass('hidden');
         $('#btnModalRegister').addClass('active');
          $('#btnModalLogin').removeClass('active');
    });
    $('#btnModalLogin').on('click',function(){
        $('#loginModalform').removeClass('hidden');
        $('.registerModalForm').addClass('hidden');
        $('#btnModalLogin').addClass('active');
        $('#btnModalRegister').removeClass('active');
    });
    const switchToScreen2 = () => {
        $('.login-modal.screen-1').addClass('hidden');
        $('.login-modal.screen-2').removeClass('hidden');
    };
    $('#screen1Login').on('click', switchToScreen2);
    $('.goto-register').on('click', function () {
        switchToScreen2();
        $('#btnModalRegister').trigger('click');
    });
    initCouponAction('shipping');
    
}

function showAjaxError(form, msg)
{
    form.find('.show-response').html(msg);
}
function initializeAddressType(){
    var $addressType = $('select[name$="_addressType"]');
    $('.address-type-selector .address-type.active').removeClass('active');
    $addressType.val('home');
    $(".address-type.selectable[data-value=home]").addClass('active');
}

function hideAddressSuggestionOnScroll() {
    $('.custom-address-modal').on('scroll', () => {
        let $container = $('.pac-container');
        if ($container.is(':visible')) {
            $container.css('display', 'none');
        }
    }).on('click','.pac-target-input', () => {
        let $container = $('.pac-container');
        let elementOffset = $('.pac-target-input').offset().top;
        if ($container.is(':parent') && !$container.is(':visible')) {
            $container.css({
                'display': 'block',
                'top': elementOffset + 50
            });

        }
    });
}

function loginPopupGAEvents(){
    var user = dataLayer.find(o => o.user != null).user;
   
    $('.login-modal-wrapper .login-modal .screen-1--body #screen1Login').on('click', function (e) {
        dataLayer.push({
            'event': 'custom_event',
            'eventCategory': 'checkout_page',
            'eventAction': 'checkout_login',
            'eventLabel': 'checkout login click',
            'country': window.GlobalAttributes.COUNTRY,
            'language': window.GlobalAttributes.LANGUAGE,
            'screenName': 'Checkout Page',
            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
            'userId': user.user_id != '' ? user.user_id : ''
        });
    })

    $('.login-modal-wrapper .login-modal .screen-1--body .goto-register').on('click', function (e) {
        dataLayer.push({
            'event': 'custom_event',
            'eventCategory': 'checkout_page',
            'eventAction': 'checkout_register_now_click',
            'eventLabel': 'checkout register now click',
            'country': window.GlobalAttributes.COUNTRY,
            'language': window.GlobalAttributes.LANGUAGE,
            'screenName': 'Checkout Page',
            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
            'userId': user.user_id != '' ? user.user_id : ''
        });
    })

    $('.login-modal-wrapper .login-modal .screen-1--body #continueAsGuest').on('click', function (e) {
        dataLayer.push({
            'event': 'custom_event',
            'eventCategory': 'checkout_page',
            'eventAction': 'checkout_continue_as_guest',
            'eventLabel': 'checkout continue as guest',
            'country': window.GlobalAttributes.COUNTRY,
            'language': window.GlobalAttributes.LANGUAGE,
            'screenName': 'Checkout Page',
            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
            'userId': user.user_id != '' ? user.user_id : ''
        });
    })
    $('.js-us-different-address').on('click', function (e) {
    	dataLayer.push({
    	    'event': 'custom_event',
    	    'eventCategory': 'checkout_page',
    	    'eventAction': 'chkout_add_new_shipping_address_click ',
    	    'eventLabel': 'checkout add new shipping address click',
    	    'country': window.GlobalAttributes.COUNTRY,
    	    'language': window.GlobalAttributes.LANGUAGE,
    	    'screenName' : 'Checkout Page',
    	    'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
    	    'userId': user.user_id != '' ? user.user_id : ''
    	});
    })
    
    $('.order--checkout--limit').find('.save-btn').on('click', function (e) {
    	var isValid = $('#dwfrm_singleshipping_shippingAddress').valid();
    	dataLayer.push({
    	    'event': 'custom_event',
    	    'eventCategory': 'checkout_page',
    	    'eventAction': isValid ? 'checkout_add_new_shipping_address_pass' : 'checkout_add_new_shipping_address_fail',
    	    'eventLabel': isValid ? 'checkout add new shipping address success' : 'checkout add new shipping address failed',
    	    'country': window.GlobalAttributes.COUNTRY,
    	    'language': window.GlobalAttributes.LANGUAGE,
    	    'screenName' : 'Checkout Page',
    	    'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
    	    'userId': user.user_id != '' ? user.user_id : ''
    	});
    })

}

exports.init = function () {
    //addressFields on the name has been changed to shippingaddress 
    //cause we're not using isdynamicform on the checkout.
    var shippingFields = 'input[name$="_address1"], input[name$="_address2"], input[name$="_address3"], [name$="_states_state"], [name$="_city"], input[name$="_zip"], input[name$="_postal"]';
    var addressBookIdValue = $('input[name$="_addressList"]:checked').length > 0 ? $('input[name$="_addressList"]:checked').data('address').ID : '';
    formPrepare.init({
        continueSelector: '[name$="shippingAddress_save"]',
        formSelector:'[id$="singleshipping_shippingAddress"]'
    });
    $(document).ready(function () {
        if($('.is-guest-user').length > 0){
            resetShippingFormData();
        }
    });
    $('input[name$="_shippingAddress_isGift"]').on('click', giftMessageBox);

    $('.payment-method-options').on('click', isVisibleSavedAddress);


    $('.address').on('change', shippingFields, updateShippingMethodList);
    $('.address').on('change', shippingFields, formPrepare.validateForm);
    $('input[name$="_addressList"]').on('click', isAddressSelected);
    tooltip.init();
    giftMessageBox();
    toggleGiftMessageBox();
    updateShippingMethodList();
    setupUseAsBilling();
    dynamicAddress.init('.order--checkout__dynamic-form');
    detectEditChanges();
    setUpAddressId(addressBookIdValue);
    listenLoginModalClickaway();
    selectAddressType();
    savedAddressClickHandle();
    heightAdjustOnCartOpen();
    // toggleSummaryMobileView();
    triggerMobBack();
    hideAddressSuggestionOnScroll();

    $('.positivenumber').on('input',function(e) {
        this.value = this.value.replace(/\D/g,'');
    });

    loginModalInit();
    login.passwordResetPopup();
    loginPopupGAEvents();
    login.initLoginActionEvents();
};

exports.updateShippingMethodList = updateShippingMethodList;
exports.updateSummary = updateSummary;



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/checkout/shipping.js